import React from 'react';
import * as MBST from 'mb-components';
import { GroupListItem } from './styled';

interface ManageGroupsProps {}

const ManageGroupsPage: React.FC<ManageGroupsProps> = () => {
  const { userProfile } = MBST.useAuth0();

  return (
    <>
      {!userProfile && <MBST.LoadingSpinner />}
      {userProfile && (
        <>
          <MBST.A to={`/`}>&lt; Back</MBST.A>
          <MBST.Heading>Manage groups</MBST.Heading>
          <MBST.Box
            background={'gray-300'}
            direction={'column'}
            align={'start'}
            overflow={'scroll'}
            margin={{
              top: `1`,
              right: `-1.5rem`,
              bottom: `-1.5rem`,
              left: `-1.5rem`,
            }}
            padding={'6'}
          >
            {userProfile.groups.map(function (group: any) {
              return (
                <GroupListItem key={group.id}>
                  <MBST.A to={`/manage-groups/${group.id}`} color={'gray-700'}>
                    {group.name}
                  </MBST.A>
                </GroupListItem>
              );
            })}
          </MBST.Box>
        </>
      )}
    </>
  );
};

export default ManageGroupsPage;
